module.exports = __webpack_public_path__ + "media/styles/images/png/checkbox-checked-teal-5a9fa5bffb396fe3b4c4784cae13defb.png";